import { createStore } from 'zustand';

import type { JsonTreeStore } from './types';

export const createJsonTreeStore = (startExpanded: boolean) =>
  createStore<JsonTreeStore>((set) => ({
    defaultExpanded: startExpanded,
    nodeStates: new Map(),
    setNodeExpanded: (nodeId, expanded) =>
      set((state) => {
        const currentValue = state.nodeStates.get(nodeId);
        if (currentValue === expanded) {
          return state;
        }

        const nodeStates = new Map(state.nodeStates);
        nodeStates.set(nodeId, expanded);

        return { nodeStates };
      }),
    removeNode: (nodeId) =>
      set((state) => {
        if (!state.nodeStates.has(nodeId)) {
          return state;
        }

        const nodeStates = new Map(state.nodeStates);
        nodeStates.delete(nodeId);

        return { nodeStates };
      }),
    forceExpandAll: () =>
      set(() => ({
        defaultExpanded: true,
        nodeStates: new Map(),
      })),
    forceCollapseAll: () =>
      set(() => ({
        defaultExpanded: false,
        nodeStates: new Map(),
      })),
  }));
